// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"article_recommend":"19926e","article_comment_list":"a7b49c","article-insert":"848ef0"}[chunkId] + ".css";
};